module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp2_3009.89fcf5fb.png";